import { Button, Icons } from "@/components/ui";
import { useT } from "@/i18n";
import { wallMessages } from "@/i18n/messages/wall";
import "./wall-surface.css";

interface WallScopeBarProps {
  /** The scope's name ("Archived"). */
  title: string;
  onClose: () => void;
}

/**
 * Above the wall while Archived filters it (mockup `.scope`): the name in
 * Satoshi and a small close button, on one wall-chrome pill so it reads
 * over any wallpaper or app.
 */
export function WallScopeBar({ title, onClose }: WallScopeBarProps) {
  const t = useT(wallMessages);
  return (
    <div
      className="wall-chrome mb-appkit-2xl inline-flex max-w-full items-center gap-appkit-sm rounded-pill py-1 pl-4 pr-1.5"
      data-interactive="true"
      data-testid="wall-scope-bar"
    >
      <h2 className="min-w-0 break-words font-display text-appkit-large-title font-medium text-primary">
        {title}
      </h2>
      <Button
        type="button"
        variant="ghost"
        size="iconSm"
        className="shrink-0 focus-visible:ring-2 focus-visible:ring-accent"
        aria-label={t("backToProject")}
        title={t("backToProject")}
        onClick={onClose}
        data-testid="wall-scope-close"
      >
        <Icons.X className="h-3.5 w-3.5" aria-hidden="true" />
      </Button>
    </div>
  );
}
